/*
Copyright Netfoundry, Inc.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

https://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

/*jshint esversion: 6 */
/*global fetch, btoa */

/**
 * Ziti Edge Client - auto-generated from Swagger Spec version 0.26.30
 *
 * @class ZitiBrowzerEdgeClient
 * @param {(string|object)} [domainOrOptions] - The project domain or options object. If object, see the object's optional properties.
 * @param {string} [domainOrOptions.domain] - The project domain
 * @param {object} [domainOrOptions.token] - auth token - object with value property and optional headerOrQueryName and isQuery properties
 */
class ZitiBrowzerEdgeClient {

    constructor(options) {
        let domain = (typeof options === 'object') ? options.domain : options;
        this.domain = domain ? domain : 'https://demo.ziti.dev/edge/client/v1';
        if (this.domain.length === 0) {
            throw new Error('Domain parameter must be specified as a string.');
        }
        this.token = (typeof options === 'object') ? (options.token ? options.token : {}) : {};
        this.apiKey = (typeof options === 'object') ? (options.apiKey ? options.apiKey : {}) : {};
        this.logger = (typeof options === 'object') ? (options.logger ? options.logger : function() {
            /* NOP */ }) : function() {
            /* NOP */ };
        this.token_type = (typeof options === 'object') ? (options.token_type ? options.token_type : null) : null;
        this.access_token = (typeof options === 'object') ? (options.access_token ? options.access_token : null) : null;
    }

    serializeQueryParams(parameters) {
        let str = [];
        for (let p in parameters) {
            if (parameters.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + '=' + encodeURIComponent(parameters[p]));
            }
        }
        return str.join('&');
    }

    mergeQueryParams(parameters, queryParameters) {
        if (parameters.$queryParameters) {
            Object.keys(parameters.$queryParameters)
                .forEach(function(parameterName) {
                    let parameter = parameters.$queryParameters[parameterName];
                    queryParameters[parameterName] = parameter;
                });
        }
        return queryParameters;
    }

    /**
     * HTTP Request
     * @method
     * @name ZitiBrowzerEdgeClient#request
     * @param {string} method - http method
     * @param {string} url - url to do request
     * @param {object} parameters
     * @param {object} body - body parameters / object
     * @param {object} headers - header parameters
     * @param {object} queryParameters - querystring parameters
     * @param {object} form - form data object
     * @param {object} deferred - promise object
     */
    request(method, url, parameters, body, headers, queryParameters, form, deferred) {
        const queryParams = queryParameters && Object.keys(queryParameters).length ? this.serializeQueryParams(queryParameters) : null;
        const urlWithParams = url + (queryParams ? '?' + queryParams : '');

        if (body && !Object.keys(body).length) {
            body = undefined;
        }

        this.logger.trace('ZitiBrowzerEdgeClient: doing fetch to: ', urlWithParams);

        /**
         * This code runs in both the Page and the ServiceWorker,
         * so use the proper 'fetch' function depending on environment.
         */
        let fetchFunc = (typeof _ziti_realFetch !== 'undefined') ? _ziti_realFetch : fetch;

        /**
         *  Some web apps (i.e. Jenkins) use Prototype.js, which does some monkey-patching
         *  of certain JS primitives (like Array.toJSON).  The Prototype.js logic serializes
         *  JSON array in a malformed way, which will cause POST body data to be incorrect,
         *  which causes REST calls to teh Controller to fail.  We work around this issue by
         *  taking Prototype.js out of the picture for the duration of our REST call.
         */
        let _toJSON = undefined;
        if (Array.prototype.toJSON) {
            _toJSON = Array.prototype.toJSON;
            delete Array.prototype.toJSON;
        }

        fetchFunc(urlWithParams, {
            method,
            headers,
            keepalive: true,
            body: JSON.stringify(body)
        }).then((response) => {
            return response.json();
        }).then((body) => {
            deferred.resolve(body);
        }).catch((error) => {
            deferred.reject(error);
        });

        /**
         *  Restore Prototype.js monkey-patch that was (potentially) saved above.
         */
        if (_toJSON) {
            Array.prototype.toJSON = _toJSON;
        }
    };

    /**
     * Set Token
     * @method
     * @name ZitiBrowzerEdgeClient#setToken
     * @param {string} value - token's value
     * @param {string} headerOrQueryName - the header or query name to send the token at
     * @param {boolean} isQuery - true if send the token as query param, otherwise, send as header param
     */
    setToken(value, headerOrQueryName, isQuery) {
        this.token.value = value;
        this.token.headerOrQueryName = headerOrQueryName;
        this.token.isQuery = isQuery;
    };
    /**
     * Set Api Key
     * @method
     * @name ZitiBrowzerEdgeClient#setApiKey
     * @param {string} value - apiKey's value
     * @param {string} headerOrQueryName - the header or query name to send the apiKey at
     * @param {boolean} isQuery - true if send the apiKey as query param, otherwise, send as header param
     */
    setApiKey(value, headerOrQueryName, isQuery) {
        this.apiKey.value = value;
        this.apiKey.headerOrQueryName = headerOrQueryName;
        this.apiKey.isQuery = isQuery;
    };
    /**
     * Set Auth headers
     * @method
     * @name ZitiBrowzerEdgeClient#setAuthHeaders
     * @param {object} headerParams - headers object
     */
    setAuthHeaders(headerParams) {
        let headers = headerParams ? headerParams : {};
        if (!this.token.isQuery) {
            if (this.token.headerOrQueryName) {
                headers[this.token.headerOrQueryName] = this.token.value;
            } else if (this.token.value) {
                headers['Authorization'] = 'Bearer ' + this.token.value;
            }
        }
        if (!this.apiKey.isQuery && this.apiKey.headerOrQueryName) {
            headers[this.apiKey.headerOrQueryName] = this.apiKey.value;
        }
        if ((null !== this.token_type) && (null !== this.access_token)) {
            headers["Authorization"] = [this.token_type + ' ' + this.access_token];
        }
        return headers;
    };

    getDeferred() {
        var result = {};
        result.promise = new Promise(function(resolve, reject) {
            result.resolve = resolve;
            result.reject = reject;
        });
        return result;
    };

    /**
     * Returns version information
     * @method
     * @name ZitiBrowzerEdgeClient#listRoot
     * @param {object} parameters - method options and parameters
     */
    listRoot(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('GET', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
         * This endpoint is used during enrollments to bootstrap trust between enrolling clients and the Ziti Edge API.
This endpoint returns a base64 encoded PKCS7 store. The content can be base64 decoded and parsed by any library
that supports parsing PKCS7 stores.

         * @method
         * @name ZitiBrowzerEdgeClient#listWellKnownCas
         * @param {object} parameters - method options and parameters
         */
    listWellKnownCas(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/.well-known/est/cacerts';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/pkcs7-mime'];
        headers['Content-Type'] = ['application/json'];

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('GET', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Allowed authentication methods include "password", "cert", and "ext-jwt"

     * @method
     * @name ZitiBrowzerEdgeClient#authenticate
     * @param {object} parameters - method options and parameters
         * @param {} parameters.auth - 
         * @param {string} parameters.method - 
     */
    authenticate(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/authenticate';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        if (parameters['auth'] !== undefined) {
            body = parameters['auth'];
        }

        if (parameters['method'] !== undefined) {
            queryParameters['method'] = parameters['method'];
        }

        if (parameters['method'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: method'));
            return deferred.promise;
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('POST', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Completes MFA authentication by submitting a MFA time based one time token or backup code.
     * @method
     * @name ZitiBrowzerEdgeClient#authenticateMfa
     * @param {object} parameters - method options and parameters
     * @param {} parameters.mfaAuth - An MFA validation request
     */
    authenticateMfa(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/authenticate/mfa';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        if (parameters['mfaAuth'] !== undefined) {
            body = parameters['mfaAuth'];
        }

        if (parameters['mfaAuth'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: mfaAuth'));
            return deferred.promise;
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('POST', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Retrieves a list of controllers
     * @method
     * @name ZitiBrowzerEdgeClient#listControllers
     * @param {object} parameters - method options and parameters
     * @param {number} parameters.limit - 
     * @param {number} parameters.offset - 
     * @param {string} parameters.filter - 
     */
    listControllers(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/controllers';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        if (parameters['limit'] !== undefined) {
            queryParameters['limit'] = parameters['limit'];
        }

        if (parameters['offset'] !== undefined) {
            queryParameters['offset'] = parameters['offset'];
        }

        if (parameters['filter'] !== undefined) {
            queryParameters['filter'] = parameters['filter'];
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('GET', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Retrieves the API session that was used to issue the current request
     * @method
     * @name ZitiBrowzerEdgeClient#getCurrentAPISession
     * @param {object} parameters - method options and parameters
     */
    getCurrentAPISession(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/current-api-session';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('GET', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Terminates the current API session
     * @method
     * @name ZitiBrowzerEdgeClient#deleteCurrentApiSession
     * @param {object} parameters - method options and parameters
     */
    deleteCurrentApiSession(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/current-api-session';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('DELETE', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Retrieves a list of certificate resources for the current API session; supports filtering, sorting, and pagination
     * @method
     * @name ZitiBrowzerEdgeClient#listCurrentApiSessionCertificates
     * @param {object} parameters - method options and parameters
     * @param {number} parameters.limit - 
     * @param {number} parameters.offset - 
     * @param {string} parameters.filter - 
     */
    listCurrentApiSessionCertificates(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/current-api-session/certificates';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        if (parameters['limit'] !== undefined) {
            queryParameters['limit'] = parameters['limit'];
        }

        if (parameters['offset'] !== undefined) {
            queryParameters['offset'] = parameters['offset'];
        }

        if (parameters['filter'] !== undefined) {
            queryParameters['filter'] = parameters['filter'];
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('GET', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Creates an ephemeral certificate for the current API Session. This endpoint expects a PEM encoded CSRs to be provided for fulfillment as a property of a JSON payload. It is up to the client to manage the private key backing the CSR request.
     * @method
     * @name ZitiBrowzerEdgeClient#createCurrentApiSessionCertificate
     * @param {object} parameters - method options and parameters
     * @param {} parameters.sessionCertificate - The payload describing the CSR used to create a session certificate
     */
    createCurrentApiSessionCertificate(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/current-api-session/certificates';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        if (parameters['sessionCertificate'] !== undefined) {
            body = parameters['sessionCertificate'];
        }

        if (parameters['sessionCertificate'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: sessionCertificate'));
            return deferred.promise;
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('POST', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Retrieves a single ephemeral certificate by id
     * @method
     * @name ZitiBrowzerEdgeClient#detailCurrentApiSessionCertificate
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.id - The id of the requested resource
     */
    detailCurrentApiSessionCertificate(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/current-api-session/certificates/{id}';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        path = path.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('GET', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Delete an ephemeral certificateby id

     * @method
     * @name ZitiBrowzerEdgeClient#deleteCurrentApiSessionCertificate
     * @param {object} parameters - method options and parameters
         * @param {string} parameters.id - The id of the requested resource
     */
    deleteCurrentApiSessionCertificate(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/current-api-session/certificates/{id}';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        path = path.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('DELETE', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
         * Retrieves data indicating the last time data relevant to this API Session was altered that would necessitate
service refreshes.

         * @method
         * @name ZitiBrowzerEdgeClient#listServiceUpdates
         * @param {object} parameters - method options and parameters
         */
    listServiceUpdates(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/current-api-session/service-updates';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('GET', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Returns the identity associated with the API sessions used to issue the current request
     * @method
     * @name ZitiBrowzerEdgeClient#getCurrentIdentity
     * @param {object} parameters - method options and parameters
     */
    getCurrentIdentity(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/current-identity';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('GET', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Retrieves a list of authenticators assigned to the current API session's identity; supports filtering, sorting, and pagination.
     * @method
     * @name ZitiBrowzerEdgeClient#listCurrentIdentityAuthenticators
     * @param {object} parameters - method options and parameters
     * @param {number} parameters.limit - 
     * @param {number} parameters.offset - 
     * @param {string} parameters.filter - 
     */
    listCurrentIdentityAuthenticators(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/current-identity/authenticators';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        if (parameters['limit'] !== undefined) {
            queryParameters['limit'] = parameters['limit'];
        }

        if (parameters['offset'] !== undefined) {
            queryParameters['offset'] = parameters['offset'];
        }

        if (parameters['filter'] !== undefined) {
            queryParameters['filter'] = parameters['filter'];
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('GET', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Retrieves a single authenticator by id. Will only show authenticators assigned to the API session's identity.
     * @method
     * @name ZitiBrowzerEdgeClient#detailCurrentIdentityAuthenticator
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.id - The id of the requested resource
     */
    detailCurrentIdentityAuthenticator(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/current-identity/authenticators/{id}';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        path = path.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('GET', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
         * Update all fields on an authenticator by id.  Will only update authenticators assigned to the API session's
identity.

         * @method
         * @name ZitiBrowzerEdgeClient#updateCurrentIdentityAuthenticator
         * @param {object} parameters - method options and parameters
             * @param {} parameters.authenticator - An authenticator put object
             * @param {string} parameters.id - The id of the requested resource
         */
    updateCurrentIdentityAuthenticator(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/current-identity/authenticators/{id}';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        if (parameters['authenticator'] !== undefined) {
            body = parameters['authenticator'];
        }

        if (parameters['authenticator'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: authenticator'));
            return deferred.promise;
        }

        path = path.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('PUT', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
         * Update the supplied fields on an authenticator by id. Will only update authenticators assigned to the API
session's identity.

         * @method
         * @name ZitiBrowzerEdgeClient#patchCurrentIdentityAuthenticator
         * @param {object} parameters - method options and parameters
             * @param {} parameters.authenticator - An authenticator patch object
             * @param {string} parameters.id - The id of the requested resource
         */
    patchCurrentIdentityAuthenticator(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/current-identity/authenticators/{id}';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        if (parameters['authenticator'] !== undefined) {
            body = parameters['authenticator'];
        }

        if (parameters['authenticator'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: authenticator'));
            return deferred.promise;
        }

        path = path.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('PATCH', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
         * This endpoint only functions for certificates issued by the controller. 3rd party certificates are not handled.
Allows an identity to extend its certificate's expiration date by using its current and valid client certificate to submit a CSR. This CSR may be passed in using a new private key, thus allowing private key rotation.
The response from this endpoint is a new client certificate which the client must  be verified via the /authenticators/{id}/extend-verify endpoint.
After verification is completion any new connections must be made with new certificate. Prior to verification the old client certificate remains active.
         * @method
         * @name ZitiBrowzerEdgeClient#extendCurrentIdentityAuthenticator
         * @param {object} parameters - method options and parameters
             * @param {} parameters.extend - 
             * @param {string} parameters.id - The id of the requested resource
         */
    extendCurrentIdentityAuthenticator(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/current-identity/authenticators/{id}/extend';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        if (parameters['extend'] !== undefined) {
            body = parameters['extend'];
        }

        if (parameters['extend'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: extend'));
            return deferred.promise;
        }

        path = path.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('POST', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
         * After submitting a CSR for a new client certificate the resulting public certificate must be re-submitted to this endpoint to verify receipt.
After receipt, the new client certificate must be used for new authentication requests.
         * @method
         * @name ZitiBrowzerEdgeClient#extendVerifyCurrentIdentityAuthenticator
         * @param {object} parameters - method options and parameters
             * @param {} parameters.extend - 
             * @param {string} parameters.id - The id of the requested resource
         */
    extendVerifyCurrentIdentityAuthenticator(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/current-identity/authenticators/{id}/extend-verify';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        if (parameters['extend'] !== undefined) {
            body = parameters['extend'];
        }

        if (parameters['extend'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: extend'));
            return deferred.promise;
        }

        path = path.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('POST', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
         * Lists the Edge Routers that the current identity has access to via policies. The data returned
includes their address and online status

         * @method
         * @name ZitiBrowzerEdgeClient#getCurrentIdentityEdgeRouters
         * @param {object} parameters - method options and parameters
         */
    getCurrentIdentityEdgeRouters(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/current-identity/edge-routers';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('GET', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Returns details about the current MFA enrollment. If enrollment has not been completed it will return the current MFA configuration details necessary to complete a `POST /current-identity/mfa/verify`.

     * @method
     * @name ZitiBrowzerEdgeClient#detailMfa
     * @param {object} parameters - method options and parameters
     */
    detailMfa(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/current-identity/mfa';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('GET', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Allows authenticator based MFA enrollment. If enrollment has already been completed, it must be disabled before attempting to re-enroll. Subsequent enrollment request is completed via `POST /current-identity/mfa/verify`

     * @method
     * @name ZitiBrowzerEdgeClient#enrollMfa
     * @param {object} parameters - method options and parameters
     */
    enrollMfa(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/current-identity/mfa';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('POST', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Disable MFA for the current identity. Requires a current valid time based one time password if MFA enrollment has been completed. If not, code should be an empty string. If one time passwords are not available and admin account can be used to remove MFA from the identity via `DELETE /identities/<id>/mfa`.

     * @method
     * @name ZitiBrowzerEdgeClient#deleteMfa
     * @param {object} parameters - method options and parameters
         * @param {string} parameters.mfaValidationCode - 
     */
    deleteMfa(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/current-identity/mfa';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        if (parameters['mfaValidationCode'] !== undefined) {
            headers['mfa-validation-code'] = parameters['mfaValidationCode'];
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('DELETE', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Shows an QR code image for unverified MFA enrollments. 404s if the MFA enrollment has been completed or not started.

     * @method
     * @name ZitiBrowzerEdgeClient#detailMfaQrCode
     * @param {object} parameters - method options and parameters
     */
    detailMfaQrCode(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/current-identity/mfa/qr-code';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['image/png, application/json'];
        headers['Content-Type'] = ['application/json'];

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('GET', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Allows the viewing of recovery codes of an MFA enrollment. Requires a current valid time based one time password to interact with. Available after a completed MFA enrollment.

     * @method
     * @name ZitiBrowzerEdgeClient#detailMfaRecoveryCodes
     * @param {object} parameters - method options and parameters
         * @param {} parameters.mfaValidation - An MFA validation request
         * @param {string} parameters.mfaValidationCode - 
     */
    detailMfaRecoveryCodes(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/current-identity/mfa/recovery-codes';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        if (parameters['mfaValidation'] !== undefined) {
            body = parameters['mfaValidation'];
        }

        if (parameters['mfaValidationCode'] !== undefined) {
            headers['mfa-validation-code'] = parameters['mfaValidationCode'];
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('GET', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Allows regeneration of recovery codes of an MFA enrollment. Requires a current valid time based one time password to interact with. Available after a completed MFA enrollment. This replaces all existing recovery codes.

     * @method
     * @name ZitiBrowzerEdgeClient#createMfaRecoveryCodes
     * @param {object} parameters - method options and parameters
         * @param {} parameters.mfaValidation - An MFA validation request
     */
    createMfaRecoveryCodes(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/current-identity/mfa/recovery-codes';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        if (parameters['mfaValidation'] !== undefined) {
            body = parameters['mfaValidation'];
        }

        if (parameters['mfaValidation'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: mfaValidation'));
            return deferred.promise;
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('POST', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Completes MFA enrollment by accepting a time based one time password as verification. Called after MFA enrollment has been initiated via `POST /current-identity/mfa`.

     * @method
     * @name ZitiBrowzerEdgeClient#verifyMfa
     * @param {object} parameters - method options and parameters
         * @param {} parameters.mfaValidation - An MFA validation request
     */
    verifyMfa(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/current-identity/mfa/verify';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        if (parameters['mfaValidation'] !== undefined) {
            body = parameters['mfaValidation'];
        }

        if (parameters['mfaValidation'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: mfaValidation'));
            return deferred.promise;
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('POST', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * present a OTT and CSR to receive a long-lived client certificate
     * @method
     * @name ZitiBrowzerEdgeClient#enroll
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.token - 
     * @param {string} parameters.method - 
     */
    enroll(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/enroll';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers['Accept'] = ['application/x-pem-file, application/json'];
        headers['Content-Type'] = ['application/pkcs10,application/json,application/x-pem-file,text/plain'];

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        if (parameters['method'] !== undefined) {
            queryParameters['method'] = parameters['method'];
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('POST', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
         * For CA auto enrollment, an identity is not created beforehand.
Instead one will be created during enrollment. The client will present a client certificate that is signed by a
Certificate Authority that has been added and verified (See POST /cas and POST /cas/{id}/verify).

During this process no CSRs are requires as the client should already be in possession of a valid certificate.

         * @method
         * @name ZitiBrowzerEdgeClient#enrollCa
         * @param {object} parameters - method options and parameters
         */
    enrollCa(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/enroll/ca';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('POST', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
         * A caller may submit a nonce and a key id (kid) from the enrollment JWKS endpoint or enrollment JWT that will
be used to sign the nonce. The resulting signature may be validated with the associated public key in order
to verify a networks identity during enrollment. The nonce must be a valid formatted UUID.

         * @method
         * @name ZitiBrowzerEdgeClient#enrollmentChallenge
         * @param {object} parameters - method options and parameters
             * @param {} parameters.nonce - 
         */
    enrollmentChallenge(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/enroll/challenge';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        if (parameters['nonce'] !== undefined) {
            body = parameters['nonce'];
        }

        if (parameters['nonce'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: nonce'));
            return deferred.promise;
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('POST', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Enrolls an edge-router via a one-time-token to establish a certificate based identity.

     * @method
     * @name ZitiBrowzerEdgeClient#enrollErOtt
     * @param {object} parameters - method options and parameters
         * @param {} parameters.erOttEnrollmentRequest - An OTT enrollment request
     */
    enrollErOtt(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/enroll/erott';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        if (parameters['erOttEnrollmentRequest'] !== undefined) {
            body = parameters['erOttEnrollmentRequest'];
        }

        if (parameters['erOttEnrollmentRequest'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: erOttEnrollmentRequest'));
            return deferred.promise;
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('POST', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
         * Allows a router to extend its certificates' expiration date by
using its current and valid client certificate to submit a CSR. This CSR may
be passed in using a new private key, thus allowing private key rotation or swapping.

After completion any new connections must be made with certificates returned from a 200 OK
response. The previous client certificate is rendered invalid for use with the controller even if it
has not expired.

This request must be made using the existing, valid, client certificate.

         * @method
         * @name ZitiBrowzerEdgeClient#extendRouterEnrollment
         * @param {object} parameters - method options and parameters
             * @param {} parameters.routerExtendEnrollmentRequest - 
         */
    extendRouterEnrollment(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/enroll/extend/router';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        if (parameters['routerExtendEnrollmentRequest'] !== undefined) {
            body = parameters['routerExtendEnrollmentRequest'];
        }

        if (parameters['routerExtendEnrollmentRequest'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: routerExtendEnrollmentRequest'));
            return deferred.promise;
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('POST', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
         * Returns a list of JSON Web Keys (JWKS) that are used for enrollment signing. The keys listed here are used
to sign and co-sign enrollment JWTs. They can be verified through a challenge endpoint, using the public keys
from this endpoint to verify the target machine has possession of the related private key.

         * @method
         * @name ZitiBrowzerEdgeClient#getEnrollmentJwks
         * @param {object} parameters - method options and parameters
         */
    getEnrollmentJwks(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/enroll/jwks';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('GET', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
         * Enroll an identity via a one-time-token which is supplied via a query string parameter. This enrollment method
expects a PEM encoded CSRs to be provided for fulfillment. It is up to the enrolling identity to manage the
private key backing the CSR request.

         * @method
         * @name ZitiBrowzerEdgeClient#enrollOtt
         * @param {object} parameters - method options and parameters
             * @param {} parameters.ottEnrollmentRequest - An OTT enrollment request
         */
    enrollOtt(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/enroll/ott';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        if (parameters['ottEnrollmentRequest'] !== undefined) {
            body = parameters['ottEnrollmentRequest'];
        }

        if (parameters['ottEnrollmentRequest'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: ottEnrollmentRequest'));
            return deferred.promise;
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('POST', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
         * Enroll an identity via a one-time-token that also requires a pre-exchanged client certificate to match a
Certificate Authority that has been added and verified (See POST /cas and POST /cas{id}/verify). The client
must present a client certificate signed by CA associated with the enrollment. This enrollment is similar to
CA auto enrollment except that is required the identity to be pre-created.

As the client certificate has been pre-exchanged there is no CSR input to this enrollment method.

         * @method
         * @name ZitiBrowzerEdgeClient#enrollOttCa
         * @param {object} parameters - method options and parameters
             * @param {} parameters.ottEnrollmentRequest - An OTT enrollment request
         */
    enrollOttCa(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/enroll/ottca';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        if (parameters['ottEnrollmentRequest'] !== undefined) {
            body = parameters['ottEnrollmentRequest'];
        }

        if (parameters['ottEnrollmentRequest'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: ottEnrollmentRequest'));
            return deferred.promise;
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('POST', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Enrolls an identity via a one-time-token to establish an initial username and password combination

     * @method
     * @name ZitiBrowzerEdgeClient#enrollUpdb
     * @param {object} parameters - method options and parameters
         * @param {string} parameters.token - 
         * @param {} parameters.updbCredentials - 
     */
    enrollUpdb(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/enroll/updb';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        if (parameters['token'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: token'));
            return deferred.promise;
        }

        if (parameters['updbCredentials'] !== undefined) {
            body = parameters['updbCredentials'];
        }

        if (parameters['updbCredentials'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: updbCredentials'));
            return deferred.promise;
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('POST', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Returns all capabilities this version of the controller is aware of, enabled or not.
     * @method
     * @name ZitiBrowzerEdgeClient#listEnumeratedCapabilities
     * @param {object} parameters - method options and parameters
     */
    listEnumeratedCapabilities(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/enumerated-capabilities';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('GET', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Retrieves a list of external JWT signers for authentication
     * @method
     * @name ZitiBrowzerEdgeClient#listExternalJwtSigners
     * @param {object} parameters - method options and parameters
     * @param {number} parameters.limit - 
     * @param {number} parameters.offset - 
     * @param {string} parameters.filter - 
     */
    listExternalJwtSigners(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/external-jwt-signers';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        if (parameters['limit'] !== undefined) {
            queryParameters['limit'] = parameters['limit'];
        }

        if (parameters['offset'] !== undefined) {
            queryParameters['offset'] = parameters['offset'];
        }

        if (parameters['filter'] !== undefined) {
            queryParameters['filter'] = parameters['filter'];
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('GET', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Submits posture responses
     * @method
     * @name ZitiBrowzerEdgeClient#createPostureResponse
     * @param {object} parameters - method options and parameters
     * @param {} parameters.postureResponse - A Posture Response
     */
    createPostureResponse(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/posture-response';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        if (parameters['postureResponse'] !== undefined) {
            body = parameters['postureResponse'];
        }

        if (parameters['postureResponse'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: postureResponse'));
            return deferred.promise;
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('POST', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Submits posture responses
     * @method
     * @name ZitiBrowzerEdgeClient#createPostureResponseBulk
     * @param {object} parameters - method options and parameters
     * @param {} parameters.postureResponse - A Posture Response
     */
    createPostureResponseBulk(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/posture-response-bulk';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        if (parameters['postureResponse'] !== undefined) {
            body = parameters['postureResponse'];
        }

        if (parameters['postureResponse'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: postureResponse'));
            return deferred.promise;
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('POST', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Return a list of the listening Edge protocols
     * @method
     * @name ZitiBrowzerEdgeClient#listProtocols
     * @param {object} parameters - method options and parameters
     */
    listProtocols(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/protocols';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('GET', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Retrieves a list of config resources; supports filtering, sorting, and pagination. Requires admin access.

     * @method
     * @name ZitiBrowzerEdgeClient#listServices
     * @param {object} parameters - method options and parameters
         * @param {number} parameters.limit - 
         * @param {number} parameters.offset - 
         * @param {string} parameters.filter - 
         * @param {array} parameters.configTypes - 
         * @param {array} parameters.roleFilter - 
         * @param {string} parameters.roleSemantic - 
     */
    listServices(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/services';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        if (parameters['limit'] !== undefined) {
            queryParameters['limit'] = parameters['limit'];
        }

        if (parameters['offset'] !== undefined) {
            queryParameters['offset'] = parameters['offset'];
        }

        if (parameters['filter'] !== undefined) {
            queryParameters['filter'] = parameters['filter'];
        }

        if (parameters['configTypes'] !== undefined) {
            queryParameters['configTypes'] = parameters['configTypes'];
        }

        if (parameters['roleFilter'] !== undefined) {
            queryParameters['roleFilter'] = parameters['roleFilter'];
        }

        if (parameters['roleSemantic'] !== undefined) {
            queryParameters['roleSemantic'] = parameters['roleSemantic'];
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('GET', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Retrieves a single service by id. Requires admin access.
     * @method
     * @name ZitiBrowzerEdgeClient#detailService
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.id - The id of the requested resource
     */
    detailService(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/services/{id}';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        path = path.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('GET', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Update all fields on a service by id. Requires admin access.
     * @method
     * @name ZitiBrowzerEdgeClient#updateService
     * @param {object} parameters - method options and parameters
     * @param {} parameters.service - A service update object
     * @param {string} parameters.id - The id of the requested resource
     */
    updateService(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/services/{id}';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        if (parameters['service'] !== undefined) {
            body = parameters['service'];
        }

        if (parameters['service'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: service'));
            return deferred.promise;
        }

        path = path.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('PUT', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Delete a service by id. Requires admin access.
     * @method
     * @name ZitiBrowzerEdgeClient#deleteService
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.id - The id of the requested resource
     */
    deleteService(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/services/{id}';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        path = path.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('DELETE', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Update the supplied fields on a service. Requires admin access.
     * @method
     * @name ZitiBrowzerEdgeClient#patchService
     * @param {object} parameters - method options and parameters
     * @param {} parameters.service - A service patch object
     * @param {string} parameters.id - The id of the requested resource
     */
    patchService(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/services/{id}';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        if (parameters['service'] !== undefined) {
            body = parameters['service'];
        }

        if (parameters['service'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: service'));
            return deferred.promise;
        }

        path = path.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('PATCH', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Retrieves the list of edge routers permitted to handle traffic for the specified service

     * @method
     * @name ZitiBrowzerEdgeClient#listServiceEdgeRouters
     * @param {object} parameters - method options and parameters
         * @param {number} parameters.limit - 
         * @param {number} parameters.offset - 
         * @param {string} parameters.filter - 
         * @param {string} parameters.sessionToken - an optional JWT token use to authenticate the request. If provided, the token must be valid else a not authorized response is returned.
         * @param {string} parameters.id - The id of the requested resource
     */
    listServiceEdgeRouters(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/services/{id}/edge-routers';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        if (parameters['limit'] !== undefined) {
            queryParameters['limit'] = parameters['limit'];
        }

        if (parameters['offset'] !== undefined) {
            queryParameters['offset'] = parameters['offset'];
        }

        if (parameters['filter'] !== undefined) {
            queryParameters['filter'] = parameters['filter'];
        }

        if (parameters['sessionToken'] !== undefined) {
            headers['session-token'] = parameters['sessionToken'];
        }

        path = path.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('GET', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Retrieves a list of terminator resources that are assigned specific service; supports filtering, sorting, and pagination.

     * @method
     * @name ZitiBrowzerEdgeClient#listServiceTerminators
     * @param {object} parameters - method options and parameters
         * @param {number} parameters.limit - 
         * @param {number} parameters.offset - 
         * @param {string} parameters.filter - 
         * @param {string} parameters.id - The id of the requested resource
     */
    listServiceTerminators(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/services/{id}/terminators';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        if (parameters['limit'] !== undefined) {
            queryParameters['limit'] = parameters['limit'];
        }

        if (parameters['offset'] !== undefined) {
            queryParameters['offset'] = parameters['offset'];
        }

        if (parameters['filter'] !== undefined) {
            queryParameters['filter'] = parameters['filter'];
        }

        path = path.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('GET', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
         * Retrieves a list of active sessions resources; supports filtering, sorting, and pagination.

Sessions are tied to an API session and are moved when an API session times out or logs out. Active sessions
(i.e. Ziti SDK connected to an edge router) will keep the session and API session marked as active.

         * @method
         * @name ZitiBrowzerEdgeClient#listSessions
         * @param {object} parameters - method options and parameters
             * @param {number} parameters.limit - 
             * @param {number} parameters.offset - 
             * @param {string} parameters.filter - 
         */
    listSessions(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/sessions';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        if (parameters['limit'] !== undefined) {
            queryParameters['limit'] = parameters['limit'];
        }

        if (parameters['offset'] !== undefined) {
            queryParameters['offset'] = parameters['offset'];
        }

        if (parameters['filter'] !== undefined) {
            queryParameters['filter'] = parameters['filter'];
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('GET', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Create a session resource.
     * @method
     * @name ZitiBrowzerEdgeClient#createSession
     * @param {object} parameters - method options and parameters
     * @param {} parameters.session - A session to create
     */
    createSession(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/sessions';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        if (parameters['session'] !== undefined) {
            body = parameters['session'];
        }

        if (parameters['session'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: session'));
            return deferred.promise;
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('POST', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Retrieves a single session by id.
     * @method
     * @name ZitiBrowzerEdgeClient#detailSession
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.id - The id of the requested resource
     */
    detailSession(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/sessions/{id}';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        path = path.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('GET', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Delete a session by id.
     * @method
     * @name ZitiBrowzerEdgeClient#deleteSession
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.id - The id of the requested resource
     */
    deleteSession(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/sessions/{id}';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        path = path.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('DELETE', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Returns a list of spec files embedded within the controller for consumption/documentation/code geneartion
     * @method
     * @name ZitiBrowzerEdgeClient#listSpecs
     * @param {object} parameters - method options and parameters
     */
    listSpecs(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/specs';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('GET', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Returns single spec resource embedded within the controller for consumption/documentation/code geneartion
     * @method
     * @name ZitiBrowzerEdgeClient#detailSpec
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.id - The id of the requested resource
     */
    detailSpec(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/specs/{id}';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        path = path.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('GET', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Return the body of the specification (i.e. Swagger, OpenAPI 2.0, 3.0, etc).
     * @method
     * @name ZitiBrowzerEdgeClient#detailSpecBody
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.id - The id of the requested resource
     */
    detailSpecBody(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/specs/{id}/spec';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['text/yaml, application/json'];
        headers['Content-Type'] = ['application/json'];

        path = path.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('GET', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };
    /**
     * Returns version information
     * @method
     * @name ZitiBrowzerEdgeClient#listVersion
     * @param {object} parameters - method options and parameters
     */
    listVersion(parameters) {
        if (parameters === undefined) {
            parameters = {};
        }
        let deferred = this.getDeferred();
        let domain = this.domain,
            path = '/version';
        let body = {},
            queryParameters = {},
            headers = {},
            form = {};

        headers = this.setAuthHeaders(headers);
        headers['Accept'] = ['application/json'];
        headers['Content-Type'] = ['application/json'];

        queryParameters = this.mergeQueryParams(parameters, queryParameters);

        this.request('GET', domain + path, parameters, body, headers, queryParameters, form, deferred);

        return deferred.promise;
    };

}

export {
    ZitiBrowzerEdgeClient
}